import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      showReadLabel: formatMessage(messages.showReadLabel),
      findNameLabel: formatMessage(messages.findNameLabel),
    };
  }, [formatMessage]);
  return translations;
};
export default useTranslations;
